import React from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";
import {AgGridReact as Grid, AgGridColumn as Col} from "ag-grid-react";

import {DateRenderer} from "../../../components";
import {caseInsensitiveNameComparator} from "../../../utils";

const Container = styled.div`
    width: 100%;
    height: ${props => props.height}px;
`;


export default class SampleDataGrid extends React.Component {

  onGridReady = ({api}) => {
    api.sizeColumnsToFit();
  };

  render() {
    return (
      <Container height={this.props.height} className='ag-fresh'>
        <Grid
          rowData={this.props.patients}
          onGridReady={this.onGridReady}
          rowHeight={35}
          headerHeight={35}
          pagination={true}
          enableFilter={false}
          enableSorting={false}
          enableColResize={false}
          suppressMovableColumns={true}
          paginationPageSize={this.props.pageSize}
          defaultColDef={{filterParams: {newRowsAction: 'keep'}}}
          columnTypes={{
            actionsColumn: {suppressMenu: true, suppressSorting: true}
          }}
          frameworkComponents={{
            dateRenderer: DateRenderer,
            actionsRenderer: this.props.actionsRenderer
          }}
        >
          <Col
            sort="asc"
            sortedAt={0}
            field="facilityName"
            headerName="Facility Name"
          />
          <Col
            width={125}
            sortedAt={1}
            sort="asc"
            field="name"
            comparator={caseInsensitiveNameComparator}
            headerName="Patient Name"
          />
          <Col
            width={60}
            field="admissionDate"
            headerName="Admit Date"
            cellRenderer="dateRenderer"
          />
          <Col
            width={60}
            headerName="Actions"
            type="actionsColumn"
            enabled={this.props.actionsEnabled}
            cellRenderer="actionsRenderer"
          />
        </Grid>
      </Container>
    )
  }

}
SampleDataGrid.defaultProps = {
  height: 425,
  pageSize: 10,
  actionsEnabled: true
};

SampleDataGrid.propTypes = {
  height: PropTypes.number,
  pageSize: PropTypes.number,
  actionsRenderer: PropTypes.func,
  patients: PropTypes.array.isRequired,
  actionsEnabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/modules/sample/components/SampleDataGrid.js